var _path, _path2, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRestIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1422 13.1223C16.374 12.6714 17.2813 11.2141 17.2813 9.46547C17.2813 7.36485 15.9781 5.65467 14.3614 5.65467C12.7557 5.65467 11.4469 7.35936 11.4414 9.46547C11.4414 11.2141 12.3487 12.6714 13.5805 13.1223L13.5798 19.0001L15.1305 19.0001L15.1422 13.1223Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69753 12.1498C11.2817 11.0821 10.1152 6.02725 10.1152 6.02725L9.33752 6.02725L9.33742 9.91553L8.5597 9.91557L8.5598 6.0273L7.39333 6.02725L7.39323 9.91553L6.61561 9.91548L6.61566 6.02725L5.83798 6.02725C5.83798 6.02725 4.67147 11.0821 7.13582 12.1498L7.13492 19.0002L8.68564 19.0002L8.69753 12.1498Z",
    fill: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.2498,
    cy: 10.1098,
    r: 9.25978,
    stroke: "currentColor",
    strokeWidth: 1.7
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestIcon);
export default __webpack_public_path__ + "static/media/rest_icon.f341761328b7c1b414959b7e0aab0b62.svg";
export { ForwardRef as ReactComponent };